import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ICancelamentoAgendamento,
  ICreateAgendamento,
  IEditAgendamento,
  IGetAgendamentoByFilter
} from 'src/app/services/AgendamentoService/agendamento.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AgendamentoService {
  constructor(private http: HttpClient) {}

  public CreateAgendamentoEmpresa(
    body: ICreateAgendamento,
    guid: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      IdempotencyKey: guid
    });
    return this.http.post<any>(
      `${environment.baseURL}Agendamento/CreateAgendamento`,
      body,
      { headers: headers }
    );
  }

  public GetAgendamentoEmpresa({
    numeroAgendamento,
    dtInicio,
    dtFim,
    fkServico,
    nmMotorista,
    placaCavalo,
    pageNumber,
    pageSize
  }: {
    numeroAgendamento?: number;
    dtInicio?: string;
    dtFim?: string;
    fkServico?: number;
    nmMotorista?: string;
    placaCavalo?: string;
    pageNumber?: number;
    pageSize?: number;
  }): Observable<any> {
    const invalid = ['', undefined, 0, NaN, null];
    const url = `${environment.baseURL}Agendamento/GetAgendamentosFilter`;
    const params: IGetAgendamentoByFilter | any = {};

    if (!invalid.includes(numeroAgendamento)) {
      params.PK_AGND = numeroAgendamento;
    }
    if (dtInicio !== undefined && dtInicio !== null) {
      params.DT_INIC = dtInicio;
    }
    if (dtFim !== undefined && dtFim !== null) {
      params.DT_FIM = dtFim;
    }
    if (!invalid.includes(fkServico)) {
      params.FK_SRVC = fkServico ?? 0;
    }
    if (nmMotorista !== undefined && nmMotorista !== null) {
      params.NM_MTRT = nmMotorista;
    }
    if (placaCavalo !== undefined && placaCavalo !== null) {
      params.TX_PLCA_CAVA = placaCavalo;
    }
    if (!invalid.includes(pageNumber)) {
      params.PAGE_NUMBER = pageNumber;
    }
    if (!invalid.includes(pageSize)) {
      params.PAGE_SIZE = pageSize;
    }

    return this.http.get<any>(url, { params });
  }

  public GetAgendamentoById(id?: number): Observable<any> {
    let url = `${environment.baseURL}Agendamento/GetAgendamentoById`;
    if (id !== undefined) {
      url += `?id=${id}`;
    }

    return this.http.get<any>(url);
  }

  public GetReceiptAgendamentoById(id: number): Observable<any> {
    const url = `${environment.baseURL}Agendamento/GetReceiptAgendamentoById`;
    const params: any = {};

    params.id = id;

    return this.http.get<any>(url, { params });
  }

  public EditarAgendamentoEmpresa(
    pkAgendamento: number,
    body: IEditAgendamento
  ): Observable<any> {
    const url = `${environment.baseURL}Agendamento/UpdateAgendamento?id=${pkAgendamento}`;

    return this.http.put<any>(url, body);
  }

  public CancelamentoAgendamento(
    body: ICancelamentoAgendamento
  ): Observable<any> {
    const url = `${environment.baseURL}Agendamento/CancelamentoAgendamento`;

    return this.http.post<any>(url, body);
  }
}
